export default function ($translate) {
    return {
        KEYS: {
            PASSED_FAILED: 'PASSED_FAILED',
            COMPLETE_INCOMPLETE: 'COMPLETE_INCOMPLETE'
        },
        LABELS: {
            PASSED_FAILED: $translate.instant('course.statusFormat.Passed/Failed'),
            COMPLETE_INCOMPLETE: $translate.instant('course.statusFormat.Complete/Incomplete')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/statusFormat/index.js